import moment from 'moment';

export const filterList = ({ data = [], filters, startDate, endDate, assocStores }) => {
  const allStores = assocStores.filter(store => store.id !== 0).map(item => item.id.toString());

  return data?.filter(item => {
    const filterStore =
      filters.store.length === 0
        ? allStores.includes(item?.activity_store_id?.toString())
        : filters.store.includes(item?.activity_store_id?.toString());
    const filterAssociate =
      filters.associate.length === 0 || filters.associate.includes(item?.activity_associate_id?.toString());

    // Convert activity date from UTC to local timezone for comparison
    // Compare by day only to avoid timezone edge cases where times shift dates
    if (!item.activity_date) {
      return false; // Skip items without activity_date
    }
    const activityDateLocal = moment(item.activity_date).local();
    if (!activityDateLocal.isValid()) {
      return false; // Skip items with invalid dates
    }
    const filterTimeSpan = activityDateLocal.isBetween(
      moment(startDate).startOf('day'),
      moment(endDate).endOf('day'),
      'day',
      '[]'
    );

    const filterAutomationType =
      filters.automationType.length === 0 || filters.automationType.includes(item.automationType);
    return filterStore && filterAssociate && filterTimeSpan && filterAutomationType;
  });
};
